import { Col, Row } from 'antd'
import './index.scss';
import CustomToolTip from 'components/Tooltip';

const SalaryFilterInfo: React.FC<any> = (props) => {
  return (
    <Row className="account-statement-info-Mainrow">
      <Col span={12}>
        {props.data?.leftColumnData?.map((item: any) => {
          return (
            <>
              <Row className="account-statement-info-row-first">
                <Col style={{ width: "300px" }} className={"account-statement-info-row-first__title"}>{item?.title}</Col>

                {
                  item?.value !== null && item?.value?.length > 30 ?
                    <CustomToolTip className="table-tooltip" title={item?.value}>
                      <Col className={"account-statement-info-row-first__value"}>{item?.value}</Col>
                    </CustomToolTip> : <Col className={"account-statement-info-row-first__value"}>{item?.value}</Col>
                }

              </Row>
            </>
          )
        })}
      </Col>
      <Col span={8}>
        {props.data?.rightColumnData?.map((item: any) => {
          return (
            <>
              <Row className="account-statement-info-row">
                <Col span={12} className={"account-statement-info-row__title"}>{item?.title}</Col>
                <Col span={12} className={item?.key === "crBalance" ? "accountStatementInfo account-statement-info-row__value is_blue" : item?.key === "drBalance" ? "accountStatementInfo account-statement-info-row__value is_red" : "accountStatementInfo account-statement-info-row__value"} >{item?.value}</Col>
              </Row>
            </>
          )
        })}
      </Col>
    </Row>
  )
}

export default SalaryFilterInfo
